<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="房间名称">
                  <el-input style='width: 200px' placeholder="请填写房间名称" v-model="queryForm.roomName"></el-input>
              </el-form-item>
              <el-form-item label="属所酒店">
                  <hotel
                      style="width: 200px"
                      title="所属酒店"
                      labelName="hotelName"
                      labelValue="id"
                      :value="queryForm.hotelId"
                      :limit="1"
                      size="small"
                      @getValue="getHotelValueQueryForm"
                      :columns="HOTEL_code"
                      :searchs="HOTEL_search"
                      dataListUrl="/mall/hotel/findList"
                      entityBeanName="mallHotel"
                      queryEntityUrl="/mall/hotel/get"
                  >
                  </hotel>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMallHotelRoomList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMallHotelRoom"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMallHotelRoom(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMallHotelRoom(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMallHotelRoomList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMallHotelRoomList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mallHotelRoomList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="roomName"
        label="房间名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="roomPrice"
        label="房间价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="roomNumber"
        label="房间数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="breakfast"
        label="早餐"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floor"
        label="楼层"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="window"
        label="窗户"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="bedType"
        label="床型"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="area"
        label="面积"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="number"
        label="人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="network"
        label="网络"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="hotelId"
        label="属所酒店"
        width="180"
      >
        <template slot-scope="scop">
            <div>{{ scop.row.hotel.hotelName }}</div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMallHotelRoom(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMallHotelRoom(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMallHotelRoom(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mallHotelRoomStates[mallHotelRoomState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mallHotelRoom"
          ref="mallHotelRoomForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="房间名称"
            prop="roomName"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写房间名称"
              v-model="mallHotelRoom.roomName"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="房间价格"
            prop="roomPrice"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写房间价格"
              v-model="mallHotelRoom.roomPrice"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="房间数量"
            prop="roomNumber"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写房间数量"
              v-model="mallHotelRoom.roomNumber"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="早餐"
            prop="breakfast"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写是否有早餐或数量"
              v-model="mallHotelRoom.breakfast"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="楼层"
            prop="floor"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写楼层位置"
              v-model="mallHotelRoom.floor"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="窗户"
            prop="window"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写窗户信息"
              v-model="mallHotelRoom.window"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="床型"
            prop="bedType"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写床型大小"
              v-model="mallHotelRoom.bedType"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="面积"
            prop="area"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写房间面积"
              v-model="mallHotelRoom.area"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="人数"
            prop="number"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写可住几人"
              v-model="mallHotelRoom.number"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="网络"
            prop="network"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写联系网络信息"
              v-model="mallHotelRoom.network"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 200px"
              placeholder="请填写排序大小"
              v-model="mallHotelRoom.sort"
              :disabled="mallHotelRoomState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item label="所属酒店" prop="hotelId">
                <hotel
                    style="width: 200px"
                    title="选择酒店"
                    labelName="hotelName"
                    labelValue="id"
                    :value="mallHotelRoom.hotelId"
                    :limit="1"
                    :stateDisabled="mallHotelRoomState == 'check'"
                    size="small"
                    @getValue="getHotelRoomValue"
                    :columns="HOTEL_code"
                    :searchs="HOTEL_search"
                    dataListUrl="/mall/hotel/findList"
                    entityBeanName="mallHotel"
                    queryEntityUrl="/mall/hotel/get"
                >
                </hotel>
            </el-form-item>
            <el-form-item label="房间图片" prop="roomPic">
                <el-upload
                    :disabled="mallHotelRoomState == 'check'"
                    style="width: 200px"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadAvatar"
                >
                    <img v-if="mallHotelRoom.roomPic" :src="mallHotelRoom.roomPic" class="avatar" size="small" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mallHotelRoomState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import Hotel from '@/components/gridselect/gidselect';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun,upload } from '@/utils/request.js';
import { HOTEL, HOTEL_SEARCH } from '@/utils/constant'; 

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        Hotel
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMallHotelRoomList();
                    this.getMallHotelRoomList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMallHotelRoomList();
                    this.getMallHotelRoomList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                HOTEL_code: HOTEL,
                HOTEL_search: HOTEL_SEARCH,
                queryForm:{
                     roomName: '', //房间名称
                     roomPic: '', //房间图片
                     roomPrice: '', //房间价格
                     roomNumber: '', //房间数量
                     breakfast: '', //早餐
                     floor: '', //楼层
                     window: '', //窗户
                     bedType: '', //床型
                     area: '', //面积
                     number: '', //人数
                     network: '', //网络
                     sort: '', //排序
                     hotelId: '', //属所酒店
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mallHotelRoomState: 'add',
                mallHotelRoomStates: {
                    add: '新建房间',
                    check: '查看房间',
                    edit: '修改房间'
                },

                multipleSelection: [],
                mallHotelRoomList: [],
                mallHotelRoom: {
                    roomName: '', //房间名称
                    roomPic: '', //房间图片
                    roomPrice: '', //房间价格
                    roomNumber: '', //房间数量
                    breakfast: '', //早餐
                    floor: '', //楼层
                    window: '', //窗户
                    bedType: '', //床型
                    area: '', //面积
                    number: '', //人数
                    network: '', //网络
                    sort: '', //排序
                    hotelId: '', //属所酒店
                },
                btnLoading: false,

                rules: {
                    roomName: [{ required: true, message: '房间名称不能为空', trigger: 'blur' }],
                    roomPic: [{ required: true, message: '房间图片不能为空', trigger: 'blur' }],
                    roomPrice: [{ required: true, message: '房间价格不能为空', trigger: 'blur' }],
                    roomNumber: [{ required: true, message: '房间数量不能为空', trigger: 'blur' }],
                    breakfast: [{ required: true, message: '早餐不能为空', trigger: 'blur' }],
                    floor: [{ required: true, message: '楼层不能为空', trigger: 'blur' }],
                    window: [{ required: true, message: '窗户不能为空', trigger: 'blur' }],
                    bedType: [{ required: true, message: '床型不能为空', trigger: 'blur' }],
                    area: [{ required: true, message: '面积不能为空', trigger: 'blur' }],
                    number: [{ required: true, message: '人数不能为空', trigger: 'blur' }],
                    network: [{ required: true, message: '网络不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    hotelId: [{ required: true, message: '属所酒店不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMallHotelRoomList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMallHotelRoomList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mallHotelRoomList = [];
            },
            resetDialog() {
                this.mallHotelRoomState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      roomName: '', //房间名称
                      roomPic: '', //房间图片
                      roomPrice: '', //房间价格
                      roomNumber: '', //房间数量
                      breakfast: '', //早餐
                      floor: '', //楼层
                      window: '', //窗户
                      bedType: '', //床型
                      area: '', //面积
                      number: '', //人数
                      network: '', //网络
                      sort: '', //排序
                      hotelId: '', //属所酒店
                };
                this.getMallHotelRoomList();
            },
            closeDialog() {
                this.showDialog = false
                this.mallHotelRoom = {
                      roomName: '', //房间名称
                      roomPic: '', //房间图片
                      roomPrice: '', //房间价格
                      roomNumber: '', //房间数量
                      breakfast: '', //早餐
                      floor: '', //楼层
                      window: '', //窗户
                      bedType: '', //床型
                      area: '', //面积
                      number: '', //人数
                      network: '', //网络
                      sort: '', //排序
                      hotelId: '', //属所酒店
                };
            },
            submitForm() {
                if (this.mallHotelRoomState == 'add') {
                    this.$refs.mallHotelRoomForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mall/hotelroom/add`,{ ...this.mallHotelRoom }).then((res) => {
                                if (res.success && res.code == 200) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMallHotelRoomList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mallHotelRoomState == 'edit') {
                    this.$refs.mallHotelRoomForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mallHotelRoom.hotel

                            post(`/mall/hotelroom/edit`,{ ...this.mallHotelRoom }).then((res) => {
                                if (res.success && res.code == 200) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMallHotelRoomList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMallHotelRoom() {
                this.showDialog = true;
                this.mallHotelRoomState = 'add';
            },
            checkMallHotelRoom(mallHotelRoomId) {
                console.log(mallHotelRoomId);
                this.currentMallHotelRoomId = mallHotelRoomId;

                this.getMallHotelRoomById();
                this.showDialog = true;
                this.mallHotelRoomState = 'check';
            },
            editMallHotelRoom(mallHotelRoomId) {
                console.log('mallHotelRoom', mallHotelRoomId);
                if (mallHotelRoomId) {
                    this.currentMallHotelRoomId = mallHotelRoomId;
                    this.getMallHotelRoomById();
                } else {
                    this.mallHotelRoom = { ...this.mallHotelRoom, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mallHotelRoomState = 'edit';
            },
            deleteMallHotelRoom(mallHotelRoomId) {
                let ids = '';
                if (mallHotelRoomId) {
                    ids = mallHotelRoomId;
                } else {
                    ids = this.multipleSelection.map((mallHotelRoom) => mallHotelRoom.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mall/hotelroom/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMallHotelRoomList();
                                this.getMallHotelRoomList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMallHotelRoomList() {
                this.resetMallHotelRoomList();
                this.getMallHotelRoomList();
            },
            getMallHotelRoomList(query = {}) {
                this.loading = true;
                get(`/mall/hotelroom/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mallHotelRoomList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMallHotelRoomById() {
                get(`/mall/hotelroom/get`,{ id: this.currentMallHotelRoomId }).then((res) =>{
                    if(res.success){
                      this.mallHotelRoom = { ...this.mallHotelRoom, ...res.mallHotelRoom };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMallHotelRoomList() {
                //this.btnLoading = true;
                exprotExcel(`/mall/hotelroom/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mall/hotelroom/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mall/hotelroom/importData`,formData);
              this.refreshMallHotelRoomList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMallHotelRoomList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMallHotelRoomList();
            },
            //上传缩略图
            uploadAvatar(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(`/mpp/image/upload`, formData).then((res) => {
                    if (res.success) {
                        this.mallHotelRoom.roomPic = res.url;
                    }
                });
            },
            getHotelRoomValue(value){
                this.mallHotelRoom.hotelId = value
            },
            getHotelValueQueryForm(value){
                this.queryForm.hotelId = value
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px !important;
    height: 200px !important;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
</style>